<template>
  <div>
    <div class="tree-wrap" :style="{ height : height }">
      <div class="el-tree-1">
        <el-tree ref="tree" :data="tree_list" :empty-text="emptyText" :props="defaultProps" :lazy="true" :load="getData" @node-click="nodeClick"></el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "FlowTypeTree",
  props:{
    height:{
      type:String,
      default() {
        return "calc( 100vh - 150 px )";
      }
    }

  },
  data(){
    return {
      tree_list:[],
      emptyText: '没有数据',
      defaultProps: {
        children: '',
        label: 'name'
      },
    }
  },
  mounted() {
    this.checkedGetList(0)
  },
  methods:{
    //单选部门list
    checkedGetList(pid) {
      var that=this;
      Http.get("flow/FlowType/getList",{
        where:JSON.stringify({pid:pid}),
        field:"id,name",
        page: 1,
        page_size: 100
      },res=>{
        if (res.code === 1) {
          that.tree_list = res.data.list;
        }
        else {
          that.$message.error({
            message: res.msg,
            type: "error",
          });

        }
      })
    },

    //节点下面的数据
    getData(node, resolve) {
      //console.log(node.level, node.data)
      var region_id = node.data.id;//选中节点id
      // console.log(region_id);
      var _this = this;
      setTimeout(() => {
        //节点不能为空
        if (region_id == '' || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;

        node.data && Http.get('flow/FlowType/getList', {
          where:JSON.stringify({pid:node.data.id}),
          field:"id,name",
          page: 1,
          page_size: 100
        }, ret => { // 异步执行成功后
          return resolve(ret.data.list);
        });
      }, 300);

    },

    //点击树形节点+搜索  = 输出表格
    nodeClick(data, node) {
      this.$emit('nodeClick', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-wrap {
  width: 200px;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowTypeTree.vue